import React from 'react';
import {
	Button, ButtonGroup, Input, Label,
	Modal,
	ModalBody,
	ModalHeader,
	Col,
	FormGroup, Form, ModalFooter
} from "reactstrap";
import TextLabel from "../../Controls/TextLabel.mjs";
import ReactQuill from "react-quill";
import appLib from "../../libs/appLib.mjs";
import "./InjectionEditor.css";

const G = window.glob;

class InjectionEditor extends React.Component {
	constructor(props) {
		super(props);
		this.state = {modal: false};
		this.uid = G.generateUid('InjectionEditor');
		this.toggleModal = this.toggleModal.bind(this);
		this.keepChanges = this.keepChanges.bind(this);
		this.commit = this.commit.bind(this);
	}

	componentDidMount() {
		G.register('InjectionEdit', data => {
			this.setState({
				modal: !!data?.id,
				injection: data,
				newData: {id: data?.id, data: {} },
				changed: false
			});
		}, this.uid);
	}

	componentWillUnmount() {
		G.unregister('InjectionEdit', this.uid);
	}

	toggleModal() {
		this.setState({modal: !this.state.modal});
	}

	keepChanges(field, value) {
		const ns = this.state.newData;
		ns.data[field] = value;
		this.setState({newData: ns, changed: true});
	}

	commit(evt) {
		try { evt.preventDefault(); } catch (e) { }
		window.setTimeout(() => {
			if ( this.state.changed ) G.trigger('InjectionChanged', this.state.newData );
			this.setState({ modal: false });
		})
		return false;
	}

	render() {
		const body = this.state.newData?.data?.body ?? this.state.injection?.body ?? this.state.injection?.data?.body;
		//const isHtml = this.state.injection?.html ?? this.state.injection?.data?.html;
		const subject = this.state.newData?.data?.subject ?? this.state.injection?.subject ?? this.state.injection?.data?.subject;
		return (
			<Modal
				className={'InjectionEditor'}
				id={this.uid}
				size='lg'
				isOpen={this.state.modal}
				toggle={this.toggleModal}
			>
				<ModalHeader toggle={this.toggleModal}>
					{this.state.injection?.name}
				</ModalHeader>
				<Form onSubmit={ this.commit }>
					<ModalBody>
						{this.state.injection?.desc && <p>{this.state.injection?.desc}</p>}
						{ typeof subject === 'string' && (<FormGroup style={{alignItems: "baseline"}} row>
							<Label for={this.uid + 'subject'}>
								<TextLabel value={"Subject"}/>:
							</Label>
							<Col>
								<Input
									id={this.uid + 'subject'}
									autoComplete={"false"}
									autoSave={"false"}
									type="text"
									value={subject}
									onChange={e => {
										this.keepChanges('subject', e.target.value)
									}}
								/>
							</Col>
						</FormGroup>)}
						<ReactQuill
							theme="snow"
							modules={{toolbar: appLib.toolbarOptions()}}
							value={body}
							onChange={x => {
								this.keepChanges('body', x)
							}}
						/>
					</ModalBody>
					<ModalFooter>
						<ButtonGroup>
							<Button
								className={"btn-icon"}
								onClick={this.toggleModal}
							>
								<i>
									<TextLabel value={"cancel"} lang={"icon"}/>
								</i>
								<b>
									<TextLabel value={"Cancel"}/>
								</b>
							</Button>
							<Button
								className={"btn-icon"}
								color={"primary"}
								disabled={!this.state.changed}
								type="submit"
							>
								<b>
									<TextLabel value={"Save"}/>
								</b>
								<i>
									<TextLabel value={"forward"} lang={"icon"}/>
								</i>
							</Button>
						</ButtonGroup>
					</ModalFooter>
				</Form>
			</Modal>
		)
	}
}

export default InjectionEditor;